import moment from 'moment';
import { org } from '../types';


const INITIAL_STATE = {
    error: undefined,
    orgList: [],
    orgListDropdown: [],
    vendorOrgListDropdown: [],
    orgDetail: {},
    orgListAtEnd: false,
    orgContacts: [],
    orgEndUsers: [],
    orgContactsDropdown: {},
    orgEndUsersDropdown: {},
    orgBranches: {},
    orgBranchesHasMore: {},
    orgBranchesDropdown: {},
    poOrgListDropdown: [],
    termsAndConditions: {},
};


const orgReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case org.GET_ORG_LIST_SUCCESS: {
            const { data, page } = action.payload;
            if (!Array.isArray(data)) return state;

            let orgList = [];
            if (page === 1) orgList = data;
            else orgList = [...state.orgList, ...data];
            return {
                ...state,
                orgList: orgList,
                orgListAtEnd: data.length === 0,
            };
        }


        case org.GET_ORG_DROPDOWN_LIST_DATA_SUCCESS: {
            const { data = [], query } = action.payload || {};
            const list = (query?.length > 0 && Array.isArray(state.orgListDropdown) && Array.isArray(data))
                ? [...state.orgListDropdown, ...data]
                : data || [];

            const uniqueList = [...new Map(list.map(item => [item.value, item])).values()];

            return {
                ...state,
                orgListDropdown: uniqueList,
            };
        }

        case org.GET_VENDOR_ORG_DROPDOWN_LIST_DATA_SUCCESS: {
            const { data = [], query } = action.payload || {};
            const list = (query?.length > 0 && Array.isArray(state.orgListDropdown) && Array.isArray(data))
                ? [...state.orgListDropdown, ...data]
                : data || [];

            const uniqueList = [...new Map(list.map(item => [item.value, item])).values()];

            return {
                ...state,
                vendorOrgListDropdown: uniqueList,
            };
        }

        case org.CLEAR_VENDOR_ORG_LIST_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                vendorOrgListDropdown: INITIAL_STATE.vendorOrgListDropdown,
            };
        }

        case org.GET_ORG_LIST_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        case org.RESET_ORG_DROPDOWN_LIST:
            return {
                ...state,
                orgListDropdown: [],
            };

        case org.GET_ORG_DETAIL_SUCCESS: {
            const data = action.payload;
            return {
                ...state,
                orgDetail: {
                    ...state.orgDetail,
                    [data.id]: data,
                },
            };
        }

        case org.GET_ORG_CONTACTS_SUCCESS: {
            const { data, page } = action.payload;
            if (!Array.isArray(data)) return state;

            let orgContacts = [];
            if (page === 1) orgContacts = data;
            else orgContacts = [...state.orgContacts, ...data];
            return {
                ...state,
                orgContacts: orgContacts,
                orgContactsAtEnd: data.length === 0,
            };


        }

        case org.GET_ORG_CONTACTS_DROPDOWN_SUCCESS: {
            const { data, orgId, query } = action.payload;
            if (!Array.isArray(data)) return state;
            let orgContactsDropdown;
            if (query?.length > 0) {
                orgContactsDropdown = [...(state.orgContactsDropdown?.[orgId] || []), ...data];
            } else {
                orgContactsDropdown = data;
            }
            orgContactsDropdown = Array.from(new Map(orgContactsDropdown.map(item => [item.id, item])).values());
            return {
                ...state,
                orgContactsDropdown: {
                    ...state.orgContactsDropdown,
                    [orgId]: orgContactsDropdown,
                },
            };
        }


        case org.GET_ORG_END_USERS_SUCCESS: {
            const { data, orgId } = action.payload;
            return {
                ...state,
                orgEndUsers: {
                    ...state.orgEndUsers,
                    [orgId]: data,
                },
            };
        }

        case org.GET_ORG_END_USERS_DROPDOWN_SUCCESS: {
            const { data, orgId, query } = action.payload;
            if (!Array.isArray(data)) return state;
            let orgEndUsersDropdown;
            if (query?.length > 0) {
                orgEndUsersDropdown = [...(state.orgEndUsersDropdown?.[orgId] || []), ...data];
            } else {
                orgEndUsersDropdown = data;
            }
            orgEndUsersDropdown = Array.from(new Map(orgEndUsersDropdown.map(item => [item.id, item])).values());
            return {
                ...state,
                orgEndUsersDropdown: {
                    ...state.orgEndUsersDropdown,
                    [orgId]: orgEndUsersDropdown,
                },
            };
        }

        case org.GET_ORG_BRANCHES_DROPDOWN_SUCCESS: {
            const { data, orgId, query } = action.payload;
            if (!Array.isArray(data)) return state;
            let orgBranchesDropdown;
            if (query?.length > 0) {
                orgBranchesDropdown = [...(state.orgBranchesDropdown?.[orgId] || []), ...data];
            } else {
                orgBranchesDropdown = data;
            }
            orgBranchesDropdown = Array.from(new Map(orgBranchesDropdown.map(item => [item.id, item])).values());
            return {
                ...state,
                orgBranchesDropdown: {
                    ...state.orgBranchesDropdown,
                    [orgId]: orgBranchesDropdown,
                },
            };
        }

        case org.GET_ORG_BRANCHES_SUCCESS: {
            const { data, orgId, page, limit } = action.payload;
            if (!Array.isArray(data)) return state;
            const previous = page > 1 ? state.orgBranches[orgId] || [] : [];
            const branches = Array.from(new Map([...previous, ...data].map(branch => [branch.id, branch])).values());
            return {
                ...state,
                orgBranches: {
                    ...state.orgBranches,
                    [orgId]: branches,
                },
                orgBranchesHasMore: {
                    ...state.orgBranchesHasMore,
                    [orgId]: data.length === limit,
                },
            };
        }

        case org.CLEAR_ORG_BRANCHES_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                orgBranchesDropdown: INITIAL_STATE.orgBranchesDropdown,
            };
        }

        case org.CLEAR_ORG_CONTACTS_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                orgContactsDropdown: INITIAL_STATE.orgContactsDropdown,
            };
        }

        case org.CLEAR_ORG_LIST_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                orgListDropdown: INITIAL_STATE.orgListDropdown,
            };
        }

        case org.CLEAR_ORG_END_USERS_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                orgEndUsersDropdown: INITIAL_STATE.orgEndUsersDropdown,
            };
        }

        case org.GET_PO_ORG_DROPDOWN_LIST_DATA_SUCCESS: {
            const { data = [], query } = action.payload || {};
            const list = (query?.length > 0 && Array.isArray(state.poOrgListDropdown) && Array.isArray(data))
                ? [...state.poOrgListDropdown, ...data]
                : data || [];

            const uniqueList = [...new Map(list.map(item => [item.value, item])).values()];

            return {
                ...state,
                poOrgListDropdown: uniqueList,
            };
        }

        case org.CLEAR_PO_ORG_LIST_DROPDOWN_LIST_DATA: {
            return {
                ...state,
                poOrgListDropdown: INITIAL_STATE.poOrgListDropdown,
            };
        }

        case org.GET_PO_TERMS_AND_CONDITIONS_LIST_SUCCESS: {
            const { remark, org_id } = action.payload;
            return {
                ...state,
                termsAndConditions: {
                    ...state.termsAndConditions,
                    [org_id]: remark,
                },
            };
        }

        default:
            return {
                ...state,
            };

    }
};

export default orgReducer;